import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";
import { getUserData } from "../components/login/LoginSlice";

const PrivateRoute = () => {
  const AuthData = useSelector(getUserData);

  return AuthData ? <Outlet /> : <Navigate to="/" />;
};

export default PrivateRoute;
